const OFFICIAL_STORE_TYPES = {
  OFFICIAL_STORE_LABEL: 'official-store-label',
};
const OFFICIAL_STORE = 'official-store';

export { OFFICIAL_STORE_TYPES, OFFICIAL_STORE };
